"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'zh-CN': {
    i18n: '多语言'
  },
  'en-US': {
    i18n: 'Internationalization'
  }
};
exports.default = _default;